<div class="p-3">
  <div>
    <h2 class="text-center text-primary">Bilanciamento Carico FamilyTutor</h2>
  </div>

  <div class="d-flex flex-wrap gap-2 mt-4" role="group" aria-label="Filtra per macroarea">
    <button
      type="button"
      class="btn btn-sm"
      [ngClass]="selectedGroup === 'all' ? 'btn-primary' : 'btn-outline-primary'"
      [attr.aria-pressed]="selectedGroup === 'all'"
      (click)="selectGroup('all')"
    >
      Tutte
    </button>
    <button
      *ngFor="let group of groups"
      type="button"
      class="btn btn-sm"
      [ngClass]="selectedGroup === group.id ? 'btn-primary' : 'btn-outline-primary'"
      [attr.aria-pressed]="selectedGroup === group.id"
      (click)="selectGroup(group.id)"
    >
      {{ group.label }}
    </button>
  </div>
  <p class="text-muted small mt-2 mb-0">
    Il peso va da 0 a 1 e viene salvato da solo a ogni modifica.
  </p>

  <div class="table-scroll mt-3">
    <table class="fh-table">
      <thead>
        <tr class="text-center">
          <th rowspan="2" class="operator-col">Operatore</th>
          <th rowspan="2">In vacanza</th>
          <th
            *ngFor="let group of visibleGroups"
            class="group-th"
            [attr.colspan]="group.lines.length"
          >
            {{ group.label }}
          </th>
        </tr>
        <tr class="text-center">
          <ng-container *ngFor="let group of visibleGroups">
            <th
              *ngFor="let line of group.lines; let first = first"
              class="line-th"
              [class.group-start]="first"
            >
              {{ line.label }}
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoading">
          <td [attr.colspan]="columnCount" class="text-center text-muted" role="status">
            Caricamento degli operatori in corso...
          </td>
        </tr>
        <tr *ngIf="!isLoading && loadFailed">
          <td [attr.colspan]="columnCount" class="text-center" role="alert">
            Non è stato possibile caricare gli operatori.
            <button type="button" class="btn btn-link p-0 align-baseline" (click)="getUsers()">
              Riprova
            </button>
          </td>
        </tr>
        <tr
          *ngFor="let record of loadBalanceRecords; let i = index"
          [formGroup]="getOperatorFormGroup(i)"
        >
          <td class="operator-col">
            {{ record.operator }}
            <span *ngIf="record.isExpired && record.factorExpiry"
              ><i
                [ngbTooltip]="
                  'Boost attivo fino alle: ' + (record.factorExpiry | extractTime)
                "
                class="ms-2 bi bi-rocket-takeoff"
              ></i
            ></span>
          </td>
          <td>
            <select
              class="form-control form-control-sm vacation-select"
              formControlName="onVacation"
              [attr.aria-label]="'In vacanza: ' + record.operator"
              [ngClass]="cellClass(i, 'vacation')"
              (change)="updateOperatorVacation(i)"
            >
              <option value="true">Si</option>
              <option value="false">No</option>
            </select>
          </td>
          <ng-container *ngFor="let group of visibleGroups">
            <td *ngFor="let line of group.lines; let first = first" [class.group-start]="first">
              <input
                class="form-control form-control-sm weight-input"
                type="number"
                min="0"
                max="1"
                step="0.1"
                [formControlName]="line.control"
                [attr.aria-label]="line.label + ': ' + record.operator"
                [ngClass]="cellClass(i, line.businessLine)"
                (change)="updateOperatorWeight(i, line.businessLine)"
              />
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="!isLoading && !loadFailed && loadBalanceRecords.length === 0">
          <td [attr.colspan]="columnCount" class="text-center">
            Non sono stati trovati operatori
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
